import React, { memo, useEffect, useState, useCallback } from 'react';
import { Tabs, NoData, Loading } from '@components/index';
import { connect, useSelector } from 'react-redux';
// import '@style/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';
// import '@style/modules/analysis/keyContactsPreview.scss';
import '../../../../styles/modules/analysis/keyContactsPreview.scss';
import { API } from '@service';
import { verifyServerData } from '@modules/analysis/detail/keyContracts/validator';
import { Button } from 'antd';
import KeyContractsEdit from '@modules/analysis/detail/keyContracts/keyContractsEdit';
import { dataForRedux } from '@modules/analysis/detail/keyContracts/Mapper';
import actions from '@flux/action';
import TabContent from '@modules/analysis/detail/keyContracts/tabContent';
import { getValueFromSearchParam, setURLSearchParam } from '@utils/history';
import { useHistory } from 'react-router-dom';

function KeyContracts({ isSingleCompany, saveKeyContactsData, refetch }) {
  const [isLoading, setIsLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [error, setError] = useState(null);
  const { tab: defaultValue } = getValueFromSearchParam('tab');

  const history = useHistory();
  const onTabChange = useCallback((e, tab) => {
    if (tab) {
      setURLSearchParam(history, { tab });
    }
  }, []);
  const { projectId, reduxKeyContractsData } = useSelector(
    ({ common, analysis }) => ({
      projectId: common.currentId,
      reduxKeyContractsData: [
        {
          companyName: common.projectCompanyInfo.buyerName,
          tableContent: analysis.keyContactsData.buyer.executives.filter(
            (e) => e.shouldDisplay,
          ),
        },
        {
          companyName: common.projectCompanyInfo.targetName,
          tableContent: analysis.keyContactsData.target.executives.filter(
            (e) => e.shouldDisplay,
          ),
        },
      ],
    }),
  );

  useEffect(() => {
    setIsLoading(true);
    refetch();
    fetchData().then((details) => {
      const validationResult = verifyServerData(details);
      if (validationResult.valid) {
        saveKeyContactsData(dataForRedux(details));
        setIsLoading(false);
      } else {
        setError(validationResult.errors);
      }
    });
  }, [isEditMode]);

  const fetchData = async () =>
    await API.getAnalysisData(projectId, 'Key Contacts');

  function toggleMode() {
    setIsEditMode(!isEditMode);
  }

  // const isInternal = JSON.parse(window.localStorage.userInfo || '{}').isInternal;

  return (
    <div className="analysis-right-wrapper">
      {isLoading || error ? (
        <Loading />
      ) : (
        <>
          <div className="head">
            <div className="title title-no-bottom-border">Key Contacts</div>
            <Button
              type="primary"
              onClick={toggleMode}
              className="role-control"
            >
              edit
            </Button>
          </div>
          {isEditMode && <KeyContractsEdit toggleMode={toggleMode} />}
          <Tabs
            isSingleCompany={isSingleCompany}
            defaultValue={defaultValue}
            onChange={onTabChange}
            tabs={
              Array.isArray(reduxKeyContractsData) &&
              reduxKeyContractsData.map(({ companyName, tableContent }) => ({
                label: companyName || '-',
                children:
                  tableContent && tableContent.length > 0 ? (
                    <div className="desContainer">
                      <div className="keyContractsTable">
                        <TabContent tableContent={tableContent} />
                      </div>
                    </div>
                  ) : (
                    <NoData />
                  ),
              }))
            }
          />
        </>
      )}
    </div>
  );
}

const mapStateToProps = ({ projects, login, common }) => ({
  permission: projects.userPermission,
  userInfo: login.userInfo || {},
  projectId: common.currentId,
});

const mapDispatchToProps = (dispatch) => ({
  saveKeyContactsData(data) {
    dispatch(actions.saveKeyContactsData(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(KeyContracts));
